import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import * as moment from "moment";

import { HealthSurveillanceQuestionnaireKey } from "@teamprevent/common/healthSurveillance";
import { clearQuestionnaire as clearQuestionnaireAction } from "@teamprevent/common/questionnaires/actions";
import { TaskTypes } from "@teamprevent/common/task/taskActions/models";
import { Dob as DobQuestionId } from "@teamprevent/common/healthSurveillance/questions/questionIds";
import { sections as HealthSurveillanceQuestionnaireSections } from "@teamprevent/common/healthSurveillance/questionnaire";

import { loadHealthSurveillanceQuestionnaire as loadHealthSurveillanceQuestionnaireAction } from "../actions";
import { ApplicationState } from "../../applicationState";
import { loadOhCaseDetail } from "../../crud/ohCase/actions";

export const useEmployeeDateOfBirthFromHealthSurveillanceQuestionnaire = (customerId?: string , ohCaseId?: string) => {
    const dispatch = useDispatch();

    const healthSurveillanceQuestionnaire = useSelector((state: ApplicationState) => state.questionnaires[HealthSurveillanceQuestionnaireKey]);
    const healthSurveillanceCase = useSelector((state: ApplicationState) => state.ohCases?.find(c => c.id === ohCaseId));
    const healthSurveillanceQuestionnaireTask = healthSurveillanceCase?.tasks?.find(t => t.type === TaskTypes.CompleteHealthSurveillanceQuestionnaireTask);

    const getEmployeeDateOfBirth = () => {
        const personalDetailsSection = healthSurveillanceQuestionnaire?.sections?.find(s => s.id === HealthSurveillanceQuestionnaireSections.PersonalDetails.id); // eslint-disable-line max-len
        const employeeDobString = personalDetailsSection?.questions[DobQuestionId]?.answer as string;
        const employeeDob = employeeDobString && moment(employeeDobString);
        return employeeDob;
    };

    React.useEffect(() => {
        if (!healthSurveillanceCase?.tasks?.length && ohCaseId && customerId) {
            dispatch(loadOhCaseDetail({ ohCaseId, customerId }));
        }
    }, [ohCaseId, healthSurveillanceCase]);

    React.useEffect(() => {
        if (healthSurveillanceQuestionnaireTask?.id && ohCaseId) {
            dispatch(loadHealthSurveillanceQuestionnaireAction(ohCaseId, healthSurveillanceQuestionnaireTask.id, HealthSurveillanceQuestionnaireKey));
        }
    }, [healthSurveillanceQuestionnaireTask, ohCaseId]);

    React.useEffect(() => {
        return () => {
            dispatch(clearQuestionnaireAction(HealthSurveillanceQuestionnaireKey));
        };
    }, []);

    return getEmployeeDateOfBirth();
};
